import styled from 'styled-components';

export const StyledInfoContainer = styled.div`
  background-color: ${props => props.theme.colors.background.base};
`;

export const Container = styled.div`
  margin: auto;
  max-width: 512px;
`;

export const HeadingContainer = styled.div`
  margin: ${({ theme }) => theme.spacing(14, 0)};
`;

export const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  margin: ${({ theme }) => theme.spacing(12, 0, 54, 0)};
`;

export const VerticalSpacer = styled.span`
  width: 100%;
  height: 2rem;
`;
